
/*
"ユーザーマスタ
グラフマスタ + グラフ表示マスタ"
*/
import { IGadget as ig } from '../typed/gadget';
import { IDomain as idobg, IData as idabg, CDomain, CData, IGraphData as igd, IValues as iv, CValues, ITooltip as itt, ILegend as il } from '../typed/gadget/basicGadget';
import { ISelectOption } from '../typed/wild';

export type IGadget = ig<idabg>;
export type IDomain = idobg;
export type IData = idabg;
export type IGraphData = igd;
export type IValues = iv;
export type ITooltip = itt;
export type ILegend = il;

export class CGadget implements IGadget {
  public gadgetID = 0;
  public title = '';
  public comment = '';
  public measure = '';
  public gadget = '';
  public options = {};
  public data = new CData();
}
export {
  CData,
  CDomain,
  CValues,
};


export interface VGraph {
  gadgets: IGadget[];
}

export interface VGraphEdit {
  gadget: IGadget;
  values: IValues;
}

export interface IValuesGroupID extends IValues {
  groups: IDomain[];
}

export interface VGetGraphData {
  materials: IDomain[];
  values: IValues;
  options?: object;
}

export interface VReturnGraphData {
  graphData: IGraphData[];
}
